/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useState, useEffect} from "react"
import {app, authentication} from "@microsoft/teams-js"
import userService from "../../services/user"
import LoginSuccessful from "../../components/LoginSuccessful";
import Timeout from "../../components/Timeout";
import trackingService from "../../services/tracking";


const AuthEnd: FC = () => {
  const [count, setCount] = useState(0)

  const notify = async () => {
    setCount(count + 1)
    try {
      await app.initialize()
      await userService.getCurrentUser({fetchPolicy: "network-only"})
      await trackingService.login()
      authentication.notifySuccess()
      app.notifySuccess()
    } catch (e) {
      // no-op
    }
  }

  useEffect(() => {
    notify()
  }, [])

  if (count > 1) {
    return <Timeout/>
  }

  return (
    <LoginSuccessful notify={notify}/>
  )
}

export default AuthEnd
